/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import PerplayStatisticsControllerDtoItemRequest from '../model/PerplayStatisticsControllerDtoItemRequest';
import PerplayStatisticsControllerDtoItemResponse from '../model/PerplayStatisticsControllerDtoItemResponse';
import PerplayStatisticsControllerDtoMarketGemRequest from '../model/PerplayStatisticsControllerDtoMarketGemRequest';
import PerplayStatisticsControllerDtoMarketGemResponse from '../model/PerplayStatisticsControllerDtoMarketGemResponse';
import PerplayStatisticsControllerDtoMarketItemRequest from '../model/PerplayStatisticsControllerDtoMarketItemRequest';
import PerplayStatisticsControllerDtoMarketItemResponse from '../model/PerplayStatisticsControllerDtoMarketItemResponse';
import PerplayStatisticsControllerDtoMarketVehicleBoxRequest from '../model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest';
import PerplayStatisticsControllerDtoMarketVehicleBoxResponse from '../model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse';
import PerplayStatisticsControllerDtoMarketVehicleRequest from '../model/PerplayStatisticsControllerDtoMarketVehicleRequest';
import PerplayStatisticsControllerDtoMarketVehicleResponse from '../model/PerplayStatisticsControllerDtoMarketVehicleResponse';
import PerplayStatisticsControllerDtoNftBoxRequest from '../model/PerplayStatisticsControllerDtoNftBoxRequest';
import PerplayStatisticsControllerDtoNftBoxResponse from '../model/PerplayStatisticsControllerDtoNftBoxResponse';
import PerplayStatisticsControllerDtoNftCarRequest from '../model/PerplayStatisticsControllerDtoNftCarRequest';
import PerplayStatisticsControllerDtoNftCarResponse from '../model/PerplayStatisticsControllerDtoNftCarResponse';
import PerplayStatisticsControllerDtoNftLevelStatRequest from '../model/PerplayStatisticsControllerDtoNftLevelStatRequest';
import PerplayStatisticsControllerDtoNftLevelStatResponse from '../model/PerplayStatisticsControllerDtoNftLevelStatResponse';
import PerplayStatisticsControllerDtoTokenRequest from '../model/PerplayStatisticsControllerDtoTokenRequest';
import PerplayStatisticsControllerDtoTokenResponse from '../model/PerplayStatisticsControllerDtoTokenResponse';
import PerplayStatisticsControllerDtoUserRequest from '../model/PerplayStatisticsControllerDtoUserRequest';
import PerplayStatisticsControllerDtoUserResponse from '../model/PerplayStatisticsControllerDtoUserResponse';

/**
* PerplayStatistics service.
* @module api/PerplayStatisticsApi
* @version 1.0
*/
export default class PerplayStatisticsApi {

    /**
    * Constructs a new PerplayStatisticsApi. 
    * @alias module:api/PerplayStatisticsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayStatisticsItemPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsItemPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoItemRequest} [perplayStatisticsControllerDtoItemRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsItemPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoItemResponse}
     */
    apiPerplayStatisticsItemPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoItemRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoItemResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/Item', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsMarketGemPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketGemPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoMarketGemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoMarketGemRequest} [perplayStatisticsControllerDtoMarketGemRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketGemPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoMarketGemResponse}
     */
    apiPerplayStatisticsMarketGemPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoMarketGemRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoMarketGemResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/MarketGem', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsMarketItemPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketItemPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoMarketItemResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoMarketItemRequest} [perplayStatisticsControllerDtoMarketItemRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketItemPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoMarketItemResponse}
     */
    apiPerplayStatisticsMarketItemPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoMarketItemRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoMarketItemResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/MarketItem', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsMarketVehicleBoxPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketVehicleBoxPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest} [perplayStatisticsControllerDtoMarketVehicleBoxRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketVehicleBoxPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse}
     */
    apiPerplayStatisticsMarketVehicleBoxPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoMarketVehicleBoxRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoMarketVehicleBoxResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/MarketVehicleBox', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsMarketVehiclePost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketVehiclePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleRequest} [perplayStatisticsControllerDtoMarketVehicleRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsMarketVehiclePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoMarketVehicleResponse}
     */
    apiPerplayStatisticsMarketVehiclePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoMarketVehicleRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoMarketVehicleResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/MarketVehicle', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsNftBoxPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsNftBoxPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoNftBoxResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoNftBoxRequest} [perplayStatisticsControllerDtoNftBoxRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsNftBoxPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoNftBoxResponse}
     */
    apiPerplayStatisticsNftBoxPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoNftBoxRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoNftBoxResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/NftBox', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsNftCarPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsNftCarPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoNftCarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoNftCarRequest} [perplayStatisticsControllerDtoNftCarRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsNftCarPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoNftCarResponse}
     */
    apiPerplayStatisticsNftCarPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoNftCarRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoNftCarResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/NftCar', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsNftLevelStatPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsNftLevelStatPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoNftLevelStatResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoNftLevelStatRequest} [perplayStatisticsControllerDtoNftLevelStatRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsNftLevelStatPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoNftLevelStatResponse}
     */
    apiPerplayStatisticsNftLevelStatPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoNftLevelStatRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoNftLevelStatResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/NftLevelStat', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsTokenPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsTokenPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoTokenResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoTokenRequest} [perplayStatisticsControllerDtoTokenRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsTokenPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoTokenResponse}
     */
    apiPerplayStatisticsTokenPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoTokenRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoTokenResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/Token', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayStatisticsUserPost operation.
     * @callback module:api/PerplayStatisticsApi~apiPerplayStatisticsUserPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerplayStatisticsControllerDtoUserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PerplayStatisticsControllerDtoUserRequest} [perplayStatisticsControllerDtoUserRequest] 
     * @param {module:api/PerplayStatisticsApi~apiPerplayStatisticsUserPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerplayStatisticsControllerDtoUserResponse}
     */
    apiPerplayStatisticsUserPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['perplayStatisticsControllerDtoUserRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PerplayStatisticsControllerDtoUserResponse;
      return this.apiClient.callApi(
        '/api/PerplayStatistics/User', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
